import { makeStyles } from '@mui/styles';

interface Props {
  children: JSX.Element | JSX.Element[];
}

const useStyles = makeStyles(() => ({
  contentWrapper: {
    marginTop: '20px',
    marginBottom: '20px',
    backgroundColor: 'rgba(240, 243, 246, 0.7)',
    padding: '25px',
    paddingTop: '20px',
    '& input': {
      background: 'white',
    },
    '& p': {
      padding: 10,
    },
    '& button': {
      marginRight: 15,
    },
  },
}));

export default function ModalContent({ children }: Props) {
  const classes = useStyles();
  return <div className={classes.contentWrapper}>{children}</div>;
}
